<form [formGroup]="filterForm">
  <div id="load-simulation-filters" class="row">
    <div class="col-md-2">
      <label>User</label>
      <ng-select
        [items]="filteredUsers"
        bindLabel="name"
        formControlName="user"
        [placeholder]="'Select'"
        [clearable]="true"
      >
      </ng-select>
    </div>
    <div class="col-md-2">
      <label>Customer</label>
      <ng-select
        [items]="filteredCustomers"
        bindLabel="name"
        formControlName="customer"
        [placeholder]="'Select'"
        [clearable]="true"
      >
      </ng-select>
    </div>
    <div class="col-md-2">
      <label>Region</label>
      <ng-select
        [items]="filteredRegions"
        bindLabel="name"
        formControlName="region"
        [placeholder]="'Select'"
        [clearable]="true"
      >
      </ng-select>
    </div>
    <div class="col-md-3">
      <label>Project</label>
      <ng-select
        [items]="filteredProjects"
        bindLabel="name"
        formControlName="project"
        [placeholder]="'Select'"
        [clearable]="true"
      >
      </ng-select>
    </div>
    <div class="col-md-3">
      <label>Simulation</label>
      <ng-select
        [items]="filteredSimulations"
        bindLabel="name"
        formControlName="simulation"
        [placeholder]="'Select'"
        [clearable]="true"
      >
      </ng-select>
    </div>
  </div>
  <div class="row reset-row">
        <div class="col-md-2">
      <button type="button" class="btn reset-btn" (click)="resetFilters(['user','customer','region','project','simulation'], true); setAllFiltered();">
        Reset Filters
      </button>
    </div>
  </div>
</form>
